var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileFiltry = function SvgMobileFiltry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    viewBox: "16.3 15.8 15.5 18.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 24h-.7c-.4-1-1.3-1.7-2.4-1.7s-2 .7-2.4 1.7h-8.3c-.4 0-.8.3-.8.8 0 .4.3.8.8.8h8.3c.3 1.1 1.3 1.9 2.5 1.9s2.2-.8 2.5-1.9h.6c.4 0 .8-.3.8-.8-.1-.4-.5-.8-.9-.8zM30.9 30.7h-8.3c-.4-1-1.3-1.7-2.4-1.7s-2.1.7-2.4 1.7h-.7c-.4 0-.8.3-.8.8 0 .4.3.8.8.8h.6c.3 1.1 1.3 1.9 2.5 1.9s2.2-.8 2.5-1.9H31c.4 0 .8-.3.8-.8-.1-.5-.5-.8-.9-.8zM17.1 19.2h.6c.3 1 1.3 1.8 2.5 1.8s2.2-.8 2.5-1.9H31c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8h-8.3c-.4-1-1.3-1.7-2.4-1.7s-2.1.7-2.4 1.7h-.7c-.4 0-.8.3-.8.8-.1.5.3.9.7.9z"
  })));
};
export default SvgMobileFiltry;